/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placefollowflyerfineprint3Inputs */

const en_placefollowflyerfineprint3 = /** @type {(inputs: Placefollowflyerfineprint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free · in the app and on the web`)
};

const de_placefollowflyerfineprint3 = /** @type {(inputs: Placefollowflyerfineprint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis · in der App und im Web`)
};

/**
* | output |
* | --- |
* | "Free · in the app and on the web" |
*
* @param {Placefollowflyerfineprint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placefollowflyerfineprint3 = /** @type {((inputs?: Placefollowflyerfineprint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placefollowflyerfineprint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placefollowflyerfineprint3(inputs)
	return de_placefollowflyerfineprint3(inputs)
});
export { placefollowflyerfineprint3 as "placeFollowFlyerFineprint" }